import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetContainerListPagingAndFilterRequest } from '../models/request/container/GetContainerListPagingAndFilterRequest';

export class ContainerService {
    static async getContainerList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getContainerList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Container/getContainerList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportContainerList(inputObj: GetContainerListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportContainerList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Container/exportContainerList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getContainerListPagingAndFilter(inputObj: GetContainerListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetContainerListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Container/GetContainerListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async addContainer(_containerId: string | undefined, _code: string | undefined, _name: string | undefined, _width: string | undefined, _length: string | undefined, _height: string | undefined, _volume: string | undefined, _doorWidth: string | undefined, _doorHeight: string | undefined, _emptyWeight: string | undefined, _maxLoadWeight: string | undefined, _ceilingHeight: string | undefined, _standartPalletCapacity: string | undefined, _euroPalletCapacity: string | undefined, _imageUrl: string | undefined, _image: File | undefined) {
        try {
            var inputObj = {
                containerId: _containerId,
                code: _code,
                name: _name,
                width: _width,
                length: _length,
                height: _height,
                volume: _volume,
                doorWidth: _doorWidth,
                doorHeight: _doorHeight,
                emptyWeight: _emptyWeight,
                maxLoadWeight: _maxLoadWeight,
                ceilingHeight: _ceilingHeight,
                standartPalletCapacity: _standartPalletCapacity,
                euroPalletCapacity: _euroPalletCapacity,
                imageUrl: _imageUrl,
                image: _image
            };

            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddContainer', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Container/AddContainer', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteContainer(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteContainer', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Container/deleteContainer', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getContainerById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getContainerById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Container/getContainerById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}